'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Home').service('LabsCommonService', ['$http', 'CommonService', 'CommonPostService',function ($http, CommonService, CommonPostService) {

	///*******PURPOSE:   GET THE ALL LABS SETTINGS INFORMATION 
	///*******CREATED BY: RAMBABU
	///*******CREATED DATE: 09/28/2015
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
	this.labsGetLabsSettingsInformation = function (postData) {
		var postData = {
			practicemodel: EMRPracticeModel
		};

		//SPECIFYING THAT IT IS A ACTION WCF CALL
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA

		return CommonService.PostData('POST', CommonService.EHR_Labs_ResultsVertical_API() + "GetLabsSettingsInformation", postData).then(function (result) { return result; });
	};


	//##################################  METHOD IS USED TO GET THE PROVIDERS LIST TO WHICH THE INBOX UNSIGNED LAB RESULTS IS LINKED BLOCK - START  ##################################
	///*******PURPOSE        : THIS METHOD IS USED TO GET THE PROVIDERS LIST TO WHICH THE INBOX UNSIGNED LAB RESULTS IS LINKED
	///*******CREATED BY     : AKBAR
	///*******CREATED DATE   : 03/16/2019
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.LabsServiceGetCustomizedProvidersToDisplayInboxUnsignedLabResults = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.UserType = EMRPracticeModel.UserType;

		//SPECIFYING THAT IT IS A ACTION WCF CALL
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Labs_Inbox_TestResults_API() + "GetCustomizedProvidersToDisplayInboxUnsignedLabResults", postData).then(function (result) { return result; });

	};
	//##################################  METHOD IS USED TO GET THE PROVIDERS LIST TO WHICH THE INBOX UNSIGNED LAB RESULTS IS LINKED BLOCK - END  ##################################

	/// *******PURPOSE: VALIDATE LAB ORDER LINKED TO DOCUMENT
	///*******CREATED BY: A. G. K
	///*******CREATED DATE:  02/21/2018
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.LabsServiceValidateLabOrdersLinkedToLabResultsDocument = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_Labs_ScanFaxDocuments_API() + "ValidateLabOrdersLinkedToLabResultsDocument", postData).then(function (result) { return result; });
	};

}]);